import CircleIcon from '@mui/icons-material/Circle';
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { useAuth } from "providers/AuthProvider";
import { usePrivacy } from "providers/PrivacyProvider";
import { useR2 } from 'providers/R2Provider';
import MainNav from "../MainNav/MainNav";
import OffCanvasPanel from "../OffCanvasPanel/OffCanvasPanel";
import SearchAndCreateBar from "../SearchAndCreateBar/SearchAndCreateBar";
import "./Taskbar.scss";

/**
 * Component for rendering the taskbar.
 * 
 * props: className, userCreatedPages (to pass through to MainNav)
*/
const Taskbar = ({ className }) => {
	const { privateMode, setPrivateMode } = usePrivacy();
	const { toggleMainNav, mainNavOpen, setMainNavOpen, userCreatedPages } = useR2();
	const { isJesseAcct } = useAuth();
	const mainNavClassName = 'mainnav--hide-all-subnavs';

	let taskbarClassName = 'taskbar';
	if (className) taskbarClassName += ` ${className}`;

	let taskbarPrivacyIndicatorClassName = 'taskbar__icon taskbar__privacy-indicator';
	if (!privateMode) taskbarPrivacyIndicatorClassName += ' taskbar__privacy-indicator--public';
	else taskbarPrivacyIndicatorClassName += ' taskbar__privacy-indicator--private';

	return (
		<div className={taskbarClassName}>
			<div className="taskbar__icon-set-secondary">
				{isJesseAcct &&
					<IconButton onClick={() => setPrivateMode(!privateMode)}>
						<CircleIcon className={taskbarPrivacyIndicatorClassName} />
					</IconButton>
				}
			</div>
			<div className="taskbar__icon-set-primary">
				<div id='taskbar-page-actions-hook'></div>
				<IconButton onClick={() => toggleMainNav()}>
					<MenuIcon className="taskbar__icon" />
				</IconButton>
				<OffCanvasPanel
					visible={mainNavOpen}
					onCloseButtonClick={() => toggleMainNav()}
					slideInDirection='left'
					closeButtonPosition=''
				>
					{isJesseAcct &&
						<div className="taskbar__mainnav-privacy-indicator">
							<IconButton onClick={() => setPrivateMode(!privateMode)}>
								<CircleIcon className={taskbarPrivacyIndicatorClassName} />
							</IconButton>
						</div>
					}
					<MainNav
						mainNavClassName={mainNavClassName}
						userCreatedPages={userCreatedPages}
					/>
					<SearchAndCreateBar onUse={() => setMainNavOpen(false)} />
				</OffCanvasPanel>
			</div>
		</div>
	);
};

export default Taskbar;
